import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { UserInputWrapper, UserInputLabel, UserInputError } from './elements';
import {
  $gray,
  $secondaryFont,
  $gold,
} from '../../../styles';

const StyledInput = styled.input`
  border: solid 1px ${$gray};
  font-size: 1rem;
  font-family: ${$secondaryFont};
  line-height: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  width: 100%;
  &:focus {
    outline-color: ${$gold};
  }
`;

const InputContainer = styled.div`
  position: relative;
`;

const IconContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  padding: 0.75rem 1rem;
  align-items: center;
  cursor: pointer;
  opacity: 0.5;
  svg {
    font-size: 1.25rem;
  }
`;

const UserPasswordInput = (props) => {
  const {
    placeholder,
    disabled,
    error,
    label,
    control,
    name,
    rules,
    className,
    onChange,
    defaultValue,
  } = props;
  const isRequired = rules && !!rules.required;
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => setShowPassword((prevShowPassword) => !prevShowPassword);
  return (
    <UserInputWrapper type="text">
      { label && <UserInputLabel required={isRequired}>{ label }</UserInputLabel> }
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ onChange: controllerOnChange, value }) => (
          <InputContainer>
            <StyledInput
              placeholder={placeholder}
              className={className}
              value={value}
              onChange={(selected) => {
                controllerOnChange(selected);
                if (onChange) {
                  onChange(selected);
                }
              }}
              disabled={disabled}
              autoComplete="off"
              autoCorrect="off"
              spellCheck="off"
              autoCapitalize="off"
              type={showPassword ? 'text' : 'password'}
            />
            <IconContainer onClick={toggleShowPassword}>
              {
                showPassword ?
                  <MdVisibilityOff />
                  : <MdVisibility />
              }
            </IconContainer>
          </InputContainer>
        )}
      />
      { error && <UserInputError>{ error.message }</UserInputError> }
    </UserInputWrapper>
  );
};

UserPasswordInput.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  rules: PropTypes.shape({
    required: PropTypes.string,
  }),
  onChange: PropTypes.func,
  control: PropTypes.shape({}).isRequired, // Provided by react-hook-form, passed in via parent
  defaultValue: PropTypes.string,
};

UserPasswordInput.defaultProps = {
  disabled: false,
  placeholder: null,
  className: null,
  error: null,
  label: null,
  rules: null,
  onChange: null,
  defaultValue: '',
};

export default UserPasswordInput;
